// Reference: https://github.com/mui/material-ui/tree/v4.x/packages/material-ui/src/utils
import { useMemo } from 'react';
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
export function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func) => {
        if (func == null) {
            return acc;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    () => { });
}
export function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        // eslint-disable-next-line no-param-reassign
        ref.current = value;
    }
}
export function useForkRef(refA, refB) {
    /**
     * This will create a new function if the ref props change and are defined.
     * This means react will call the old forkRef with `null` and the new forkRef
     * with the ref. Cleanup naturally emerges from this behavior
     */
    return useMemo(() => {
        if (refA == null && refB == null) {
            return null;
        }
        return (refValue) => {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
}
//# sourceMappingURL=utils.js.map